import { type LotteryTicketType } from '@/common/types/lottery';

const navListConfig: {
  label: string;
  ticketType: LotteryTicketType;
}[] = [
  {
    label: 'Silver',
    ticketType: 'Silver',
  },
  {
    label: 'Gold',
    ticketType: 'Gold',
  },
  {
    label: 'Diamond',
    ticketType: 'Diamond',
  },
];

export { navListConfig };
